import React from 'react';
import { Icon } from '../../components/Icon/Icon';
import { Stack } from '../../components/Stack/Stack';
import { t } from '../../locales/translate';
import './CheckoutAlert.css';
import { useCheckoutAlert } from '../../model/ticketScanner';

interface Props {
  onCheckout: () => void;
}

export function CheckoutAlert({ onCheckout }: Props): JSX.Element | null {
  const [isChecked, setIsChecked] = React.useState(false);
  const [isDisabled, persistAlert] = useCheckoutAlert();

  if (isDisabled) {
    return null;
  }

  return (
    <>
      <div className="checkout-alert__backdrop"></div>
      <div className="checkout-alert">
        <Icon name="invalid" className="checkout-alert__icon" color="#ff6056" />
        <Stack size="lg">
          <p className="checkout-alert__text">{t.page.ticketScanner.checkOutWarning}</p>

          <form
            className="checkout-alert__form"
            onSubmit={(e) => {
              e.preventDefault();

              if (isChecked) {
                persistAlert();
              }
              onCheckout();
            }}
          >
            <label htmlFor="checkout-alert" className="checkout-alert__input">
              <Stack line size="xxs">
                <div className="checkout-alert__checkbox">
                  <input
                    className="checkout-alert__input"
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => setIsChecked((c) => !c)}
                    id="checkout-alert"
                  />
                  <span className="checkout-alert__input-box"></span>
                </div>
                <p className="checkout-alert__input-text">{t.page.ticketScanner.checkOutWarningDismiss}</p>
              </Stack>
            </label>
            <button className="checkout-alert__button">{t.page.ticketScanner.checkOutWarningAccept}</button>
          </form>
        </Stack>
      </div>
    </>
  );
}
